import {
  Button,
  DialogActions,
  Dialog,
  DialogContent,
  Grid,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import DeviceUsageStatus from "../../components/DeviceUseEventModal/DeviceUsageStatus";
import DeviceUsageHistory from "../../components/DeviceUseEventModal/DeviceUsageHistory";
import React, { useEffect, useState } from "react";
import * as DATANETAPI from "../../components/DataNet/DataNet";
import LoadingPage from "../LoadingPage";

const DeviceUseEventModal = ({
  isUseEventModalOpen,
  setisUseEventModalOpen,
  currentNotifications = [],
  events = [],
  isEventsLoaded,
}) => {
  const { t } = useTranslation();

  const [pending, setPending] =
    useState(false);

  useEffect(() => {
    if (isUseEventModalOpen) {
      setPending(
        currentNotifications.length > 0
      );
    }
  }, [
    isUseEventModalOpen,
    currentNotifications,
  ]);

  const setUseEventAsReviewed = async () => {
    if (
      currentNotifications.length === 0
    ) {
      return;
    }

    const snap =
      await DATANETAPI.setReviewNofitifications(
        currentNotifications
      );

    if (snap?.status === 1) {
      setPending(false);
    }
  };

  const handleClose = () => {
    setisUseEventModalOpen(false);
  };

  return (
    <Dialog
      open={isUseEventModalOpen}
      onClose={handleClose}
    >
      <DialogContent>
        <Grid container>
          {pending &&
            currentNotifications.length >
              0 && (
              <DeviceUsageStatus
                active_notifications={
                  currentNotifications
                }
              />
            )}

          {!isEventsLoaded ? (
            <LoadingPage />
          ) : (
            <DeviceUsageHistory
              events={events}
            />
          )}
        </Grid>
      </DialogContent>

      <DialogActions
        style={{
          padding: "20px 20px",
        }}
      >
        {pending &&
          currentNotifications.length >
            0 && (
            <Button
              onClick={
                setUseEventAsReviewed
              }
              variant="contained"
              color="primary"
            >
              {t(
                "device_usage.review"
              )}
            </Button>
          )}

        <Button
          onClick={handleClose}
          color="primary"
          variant="outlined"
          autoFocus
        >
          {t("common.ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeviceUseEventModal;